export default "__VITE_ASSET__By1Vlje$__"